<template>
  <div id="home">
    <notification />
    <div class="wrap">
      <activeOption />
      <noticeElement ref="noticeElement" :notice-data-list="noticeData" />
    </div>
    <leadCenter
      ref="leadCenterPreviewBox"
      v-if="leadShow"
      :lead-data="leadData"
    />
    <activeCalendar />
  </div>
</template>
<script>
import { commonServer } from '@/API/home';
import notification from '@/components/notification';
import activeOption from './component/home/activeOption';
import activeCalendar from './component/home/activeCalendar';
import noticeElement from './component/home/notice';
import leadCenter from './component/home/leadCenter';
import { commonApi, notice } from './service';

export default {
  name: 'Home',
  data () {
    return {
      swiperOptions: {
        autoplay: {
          delay: 10000
        },
        loop: true,
        speed: 1000,
        direction: 'vertical'
      },
      noticeData: [],
      leadData: {},
      leadShow: false
    };
  },
  components: {
    notification,
    activeOption,
    noticeElement,
    activeCalendar,
    leadCenter
  },
  computed: {},
  methods: {
    updateUserLangCommand (lang) {

      window.$core = window.$core || {}
      window.$core.locale = lang === 'en-US'? 'en': "zh"

      window.localStorage.setItem('lang', lang);
      commonServer.updateUserLang().then(res => {
          if (res.status === '200') {
            this.$router.go(0);
          }
      });
    },
    setLang () {

      window.$core = window.$core || {}
      window.$core.locale = this.$route.query.lang === 'zh' ? 'zh': "en"

      window.localStorage.setItem('lang', this.$route.query.lang === 'zh' ? 'zh-CN' : 'en-US');
      commonServer.updateUserLang().then(res => {
          if (res.status === '200') {
            this.$router.go(0);
          }
      });
    },
    getHomeData () {
      let noticeParams = {
        pageNum: 1,
        pageSize: 100
      };
      let noticeArr = [
        { name: 2 },
        { name: 1 },
        { name: 3 },
        { name: 4 },
        { name: 5 }
      ];
      let leadParmas = {
        pageNum: 1,
        pageSize: 1,
        poolType: '2'
      };
      let leadArr = [];
      let { leadModule } = this.$store.state.userInfo.permissionDTO;
      if (leadModule.hasPermissionUseLead) {
        leadModule.roleList.forEach(item => {
          if (item.isDefaultRole) {
            this.leadShow = item.roleId !== 'imc_view_role';
          }
        });
      }
      let selfFollowFlag = false;
      if (this.leadShow) {
        selfFollowFlag = this.$store.state.routerMenu.routerList.some(item => {
          return item.path === 'selfFollow';
        });
        if (selfFollowFlag) {
          leadArr = [
            'privateSeaTodo',
            'privateSeaHang',
            'privateSeaDone',
            'privateSeaSelfFollow'
          ];
        } else {
          leadArr = ['privateSeaTodo', 'privateSeaHang', 'privateSeaDone'];
        }
      }

      this.$store.commit('setSubPageLoading', true);
      Promise.all([
        ...noticeArr.map(item => {
          return new Promise((resolve, reject) => {
            noticeParams = {
              ...noticeParams,
              approvalStat: item.name
            };
            notice.getPendingApproval(noticeParams).then(res => {
              if (res.status === '200') {
                resolve(res.data);
              } else {
                reject();
              }
            });
          });
        }),
        ...leadArr.map(item => {
          return new Promise((resolve, reject) => {
            leadParmas = {
              ...leadParmas,
              poolConfigType: item,
              indexFlag: 1
            };
            commonApi.getLeadData(leadParmas).then(res => {
              if (res.status === '200') {
                resolve(res.data);
              } else {
                reject(null);
              }
            });
          });
        })
      ])
        .then(res => {
          // 通告
          this.noticeData = res.splice(0, 5);
          this.$refs.noticeElement.setNoticeDefault(this.noticeData[0]);
          // 线索中心
          if (this.leadShow) {
            this.leadData = {
              privateSeaTodo: res[0],
              privateSeaHang: res[1],
              privateSeaDone: res[2]
            };
            if (selfFollowFlag) {
              this.leadData.privateSeaSelfFollow = res[3];
            }
            this.$refs.leadCenterPreviewBox.numberGrowStart();
          }
          this.$store.commit('setSubPageLoading', false);
        })
        .catch(() => {
          this.$store.commit('setSubPageLoading', false);
        });
    }
  },
  mounted () {
    if (this.$route.query.lang) {
      if (localStorage.getItem('lang')) {
        if (this.$route.query.lang === 'zh') {
          if (localStorage.getItem('lang') !== 'zh-CN') {
            this.updateUserLangCommand('zh-CN');
            console.log(1);
          }
        } else {
          if (localStorage.getItem('lang') !== 'en-US') {
            this.updateUserLangCommand('en-US');
            console.log(2);
          }
        }
      } else {
        this.setLang();
        console.log(3);
      }
    };
    this.getHomeData();
    // if (
    //   !sessionStorage.getItem('homeTipsFlag') &&
    //   this.$store.state.userInfo.userType === 'rj'
    // ) {
    //   this.$alert(
    //     '<div>因费用系统跨年结算，市场活动管理系统将于2022年12月27日24点至2023年1月2日0点期间关闭活动申请及核销功能。</div>',
    //     this.$t('notic.NOTICContent'),
    //     {
    //       confirmButtonText: '关闭',
    //       dangerouslyUseHTMLString: true
    //     }
    //   );
    //   sessionStorage.setItem('homeTipsFlag', '1');
    // }
  }
};
</script>
<style lang="scss" scoped>
#home {
  width: 100%;
  > .noticeBar {
    margin-bottom: 16px;
  }
  > .wrap {
    width: 100%;
    min-height: 333px;
    margin-bottom: 20px;
    display: flex;

    > div {
      flex: 1;
    }

    &:after {
      content: "";
      height: 0;
      display: block;
      clear: both;
    }
  }
}
</style>
